import { map, tap } from 'rxjs';

import { Injectable } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { HttpService } from '@/app/core/services/http';
import { Profile } from '@/app/api/profile/profile.types';
import { UpdateUser, UpdateUserPassword } from '@/app/api/users';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpService,
    private authStore: AuthStore,
  ) {}

  getProfileInfo() {
    return this.http.get<{ user: Profile }>('profile').pipe(
      map((profileInfo) => profileInfo.user),
      tap((user) => this.authStore.setAuthUser(user)),
    );
  }

  updateProfile(body: UpdateUser) {
    return this.http.put('profile/profile', body).pipe(tap((user) => this.authStore.setAuthUser(user)));
  }

  updateProfilePassword(body: UpdateUserPassword) {
    return this.http.put('profile/password', body);
  }
}
